import { createState } from '~/src/hooks/useEoState'
import DialogsOverlay from '~/src/types/DialogsOverlay'

export const DIALOGS_OVERLAY = createState<DialogsOverlay[]>({
  key: 'overlays',
  default: []
})
